export default __webpack_public_path__ + "static/AppStoreLinks_Hover-33dc21175c5ef3cf8b7ad658383f0a74.png";